import { api } from "../api/api";

export const teamApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTeams: builder.query({
            query: (member) => ({
                url: `teams?members_like=${member}`,
                method: "GET",
            }),
        }),
        getAllTeams: builder.query({
            query: () => ({
                url: "/teams",
                method: "GET",
            }),
        }),
        addTeam: builder.mutation({
            query: (data) => ({
                url: "/teams",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const team = await queryFulfilled;
                    // pessimistic update in team
                    dispatch(
                        api.util.updateQueryData(
                            "getTeams",
                            arg.admin,
                            (draft) => {
                                draft.push(team?.data);
                            }
                        )
                    );
                } catch (error) {}
            },
        }),
        deleteTeam: builder.mutation({
            query: ({ id, admin }) => ({
                url: `/teams/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic update in team
                try {
                    await queryFulfilled;
                    dispatch(
                        api.util.updateQueryData(
                            "getTeams",
                            arg.admin,
                            (draft) => {
                                return draft.filter(
                                    (team) => team?.id !== arg.id
                                );
                            }
                        )
                    );
                } catch (error) {}
            },
        }),
        addMember: builder.mutation({
            query: ({ id, member, members }) => ({
                url: `/teams/${id}`,
                method: "PATCH",
                body: {
                    members,
                },
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic update in team
                try {
                    await queryFulfilled;
                    dispatch(
                        api.util.updateQueryData(
                            "getTeams",
                            arg.member,
                            (draft) => {
                                const team = draft.find(
                                    (team) => team.id == arg.id
                                );
                                team.members = arg.members;
                            }
                        )
                    );
                } catch (error) {}
            },
        }),
    }),
});

export const {
    useGetTeamsQuery,
    useGetAllTeamsQuery,
    useAddTeamMutation,
    useDeleteTeamMutation,
    useAddMemberMutation,
} = teamApi;
